import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';

registerLocale('es', es);

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class GenerarCursadas extends Component {
  static displayName = GenerarCursadas.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: '',
      redirect: false,
      startDateAnual: new Date(),
      endDateAnual: new Date(),
      startDate1C: new Date(),
      endDate1C: new Date(),
      startDate2C: new Date(),
      endDate2C: new Date(),
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWCursada');
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleStartDateAnual = (date) => {
    this.clearFeedback();
    this.setState({ startDateAnual: date });
  };

  handleEndDateAnual = (date) => {
    this.clearFeedback();
    this.setState({ endDateAnual: date });
  };

  handleStartDate1C = (date) => {
    this.clearFeedback();
    this.setState({ startDate1C: date });
  };

  handleEndDate1C = (date) => {
    this.clearFeedback();
    this.setState({ endDate1C: date });
  };

  handleStartDate2C = (date) => {
    this.clearFeedback();
    this.setState({ startDate2C: date });
  };

  handleEndDate2C = (date) => {
    this.clearFeedback();
    this.setState({ endDate2C: date });
  };

  isFormValid() {
    const startDateAnual = new Date(this.state.startDateAnual);
    const endDateAnual = new Date(this.state.endDateAnual);
    const startDate1C = new Date(this.state.startDate1C);
    const endDate1C = new Date(this.state.endDate1C);
    const startDate2C = new Date(this.state.startDate2C);
    const endDate2C = new Date(this.state.endDate2C);

    return (
      startDateAnual <= endDateAnual
      && startDate1C <= endDate1C
      && startDate2C <= endDate2C
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;

    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Revise las fechas ingresadas.' });
      return;
    }

    this.generateCursadas();
  }

  async generateCursadas() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/cur/gen', {
      method: 'POST',
      body: JSON.stringify({
        FechaInicioAnual: constantClass.serializeDateForApi(this.state.startDateAnual),
        FechaInicio1C: constantClass.serializeDateForApi(this.state.startDate1C),
        FechaInicio2C: constantClass.serializeDateForApi(this.state.startDate2C),
        FechaFinAnual: constantClass.serializeDateForApi(this.state.endDateAnual),
        FechaFin1C: constantClass.serializeDateForApi(this.state.endDate1C),
        FechaFin2C: constantClass.serializeDateForApi(this.state.endDate2C),
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudieron generar las cursadas. Verifique las fechas e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-cur" />;
    }

    const {
      loading,
      errorMessage,
      startDateAnual,
      endDateAnual,
      startDate1C,
      endDate1C,
      startDate2C,
      endDate2C,
    } = this.state;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-cur">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Generar Cursadas</h1>
        <p className="md-form-page__subtitle">
          Defina las fechas de inscripción para cada período académico y genere las cursadas.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Generando cursadas, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="cursadas-inicio-anual">
                Fecha de inicio de inscripción — período anual
              </label>
              <DatePicker
                id="cursadas-inicio-anual"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={startDateAnual}
                onChange={this.handleStartDateAnual}
                disabled={loading}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="cursadas-fin-anual">
                Fecha de fin de inscripción — período anual
              </label>
              <DatePicker
                id="cursadas-fin-anual"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={endDateAnual}
                onChange={this.handleEndDateAnual}
                disabled={loading}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="cursadas-inicio-1c">
                Fecha de inicio de inscripción — primer cuatrimestre
              </label>
              <DatePicker
                id="cursadas-inicio-1c"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={startDate1C}
                onChange={this.handleStartDate1C}
                disabled={loading}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="cursadas-fin-1c">
                Fecha de fin de inscripción — primer cuatrimestre
              </label>
              <DatePicker
                id="cursadas-fin-1c"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={endDate1C}
                onChange={this.handleEndDate1C}
                disabled={loading}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="cursadas-inicio-2c">
                Fecha de inicio de inscripción — segundo cuatrimestre
              </label>
              <DatePicker
                id="cursadas-inicio-2c"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={startDate2C}
                onChange={this.handleStartDate2C}
                disabled={loading}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="cursadas-fin-2c">
                Fecha de fin de inscripción — segundo cuatrimestre
              </label>
              <DatePicker
                id="cursadas-fin-2c"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={endDate2C}
                onChange={this.handleEndDate2C}
                disabled={loading}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={loading}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
